<template>
    <div>
        <base-card>
<img class="img-fluid" src="https://static.vecteezy.com/system/resources/previews/001/857/111/non_2x/error-404-page-not-found-landing-page-concept-for-mobile-and-pc-free-vector.jpg" alt="" sizes="" srcset="">
<router-link class="d-block w-50 m-auto btn btn-primary" to='/'> Go to Home Page</router-link>
 </base-card>   </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>